<template>
    <div class="consultative">
        <!-- 轮播图 -->
        <div class="banner">
            <img src="../assets/images/search.png" alt="">
            <div class="search">
                <div class="how">我们如何为您提供帮助？</div>
                <div class="input">
                    <el-input prefix-icon="el-icon-search" placeholder="搜索" />
                </div>
            </div>
        </div>
        <!-- 按类别浏览 -->
        <div class="container category-box">
            <div class="title">按类别浏览</div>
            <div class="u-flex u-row-between category">
                <div class="category-item" v-for="(item, index) in categoryList" :key="index" @click="onGoFaq">
                    <div class="category-name">{{ item.name }}</div>
                    <div class="category-object">{{ item.object }}</div>
                </div>
            </div>
        </div>
        <!-- 联系我们 -->
        <div class="container contact-label">联系我们</div>
        <div class="contact-box">
            <div class="container">
                <div class="u-flex u-row-between contact">
                    <div class="contact-item">
                        <img src="../assets/images/27.png" alt="">
                        <div class="contact-name">联系支持人员</div>
                        <div class="contact-desc">全方位为您答疑解惑</div>
                        <el-button size="small" round>电话咨询</el-button>
                    </div>
                    <div class="contact-item">
                        <img src="../assets/images/28.png" alt="">
                        <div class="contact-name">联系策展人</div>
                        <div class="contact-desc">免费艺术咨</div>
                        <el-button size="small" round>联系我们</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            categoryList: [
                {
                    name: "订单和退货",
                    object: "对于收藏家"
                },
                {
                    name: "买家",
                    object: "对于收藏家"
                },
                {
                    name: "政策",
                    object: "对于每个人"
                }
            ]
        }

    },
    methods: {
        onGoFaq() {
            this.$router.push("/Faq")
        },
    },
    mounted() { }
}
</script>

<style scoped>
.banner {
    position: relative;
}

.banner img {
    width: 100%;
}

.search {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
}

.how {
    color: #fff;
    font-size: 32px;
}

.input {
    margin-top: 24px;
    width: 600px;
}

.input>>>.el-input__inner {
    width: 100%;
    /* height: 32px; */
    /* line-height: 32px; */
    border-radius: 32px;
}

.category-box {
    margin: 50px auto;
    padding: 0 20px;
    box-sizing: border-box;
}

.category-box .title {
    color: #000;
    font-size: 16px;
}

.category {
    margin-top: 20px;
}

.category-item {
    padding: 15px 0;
    width: calc(33.3333% - 100px);
    color: #000;
    text-align: center;
    border: 1px solid #000;
    cursor: pointer;
}

.category-name {
    font-size: 16px;
}

.category-object {
    font-size: 12px;
}

.contact-label {
    padding: 30px 20px;
    color: #000;
    font-size: 16px;
    box-sizing: border-box;
}

.contact-box {
    padding: 30px 20px;
    background: #edf1f7;
    box-sizing: border-box;
}

.contact {
    color: #fff;
}

.contact-item {
    padding: 30px 0;
    width: calc(50% - 200px);
    color: #000;
    text-align: center;
    background: #fff;
}

.contact-item img {
    margin: 0 auto;
    width: 30px;
    height: 30px;
    display: block;
}

.contact-name {
    margin-top: 10px;
    font-size: 18px;
}

.contact-desc {
    margin-top: 2px;
    font-size: 12px;
}

.contact-item .el-button {
    margin-top: 16px;
    padding: 4px 20px;
    color: #000;
    border: 1px solid #000;
}
</style>